<template>
  <v-card>
    <v-card-title>Change Product</v-card-title>
    <v-card-text>
      <generic-search
        v-model="product"
        label="Product"
        placeholder="Search Products"
        :prepend-inner-icon="mdiCube"
        :search-args="{ primaryProduct: true, carrierId }"
        :composable="useProductSearch"
        data-testid="product-input"
        :success="Boolean(product?.id)"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <app-button
        class="text-none"
        variant="outlined"
        @click="dialog.closeDialog()"
      >
        Close
      </app-button>
      <app-button
        class="text-none"
        color="primary"
        data-testid="save-product-change"
        :loading="loading"
        @click="save"
      >
        Save
      </app-button>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import GenericSearch from "@/components/shared/GenericSearch.vue";
import { mdiCube } from "@mdi/js";
import { ref } from "vue";
import { useProductSearch } from "@/components/shared/search/product-search";
import { useDialogStore } from "@/stores/dialog";
import { updateCaseProduct } from "@/api/cases.service";
import { useSnackbarStore } from "@/stores/snackbar";
import { parseErrorMessage } from "@/util/helpers";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  carrierId: {
    type: Number,
    required: true
  },
  caseId: {
    type: Number,
    required: true
  }
});

const snackbar = useSnackbarStore();
const dialog = useDialogStore();

const loading = ref(false);
const product = ref(props.modelValue);

async function save() {
  try {
    loading.value = true;
    await updateCaseProduct(props.caseId, {
      product_id: product.value.id
    });
    dialog.closeDialog({ refresh: true });
  } catch (e) {
    snackbar.showErrorSnackbar({ message: parseErrorMessage(e) });
  } finally {
    loading.value = false;
  }
}
</script>
